module.exports = __webpack_public_path__ + "img/studio7-logo-small.773c903c.svg";